export default {
  data: () => ({
    translations: {
      image: {
        el: 'Εικόνα',
        en: 'Image',
        it: 'Immagine',
      },
      addProduct: {
        el: 'Προσθήκη Προϊόντος',
        en: 'Add Product',
        it: 'Aggiungi prodotto',
      },
      addProductGroup: {
        el: 'Προσθήκη Ομάδας Προϊόντων',
        en: 'Add Product Group',
        it: 'Aggiungere un gruppo di prodotti',
      },
      productName: {
        el: 'Προϊόν',
        en: 'Product Name',
        it: 'Prodotto',
      },
      productDescription: {
        el: 'Περιγραφή Προϊόντος',
        en: 'Product Description',
        it: 'Descrizione del prodotto',
      },
      sellingPrice: {
        el: 'Τιμή Πώλησης',
        en: 'Selling Price',
        it: 'Prezzo di vendita',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      category: {
        el: 'Κατηγορία',
        en: 'Category',
        it: 'Categoria',
      },
      published: {
        el: 'Δημοσιεύτηκε',
        en: 'Published',
        it: 'Pubblicato',
      },
      actions: {
        el: 'Επεξεργασία',
        en: 'Actions',
        it: 'Modifica',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      update: {
        el: 'Ενημέρωση',
        en: 'Update',
        it: 'Aggiornamento',
      },
      delete: {
        el: 'Διαγραφή',
        en: 'Delete',
        it: 'Cancellare',
      },
      deleteProduct: {
        el: '',
        en: 'Delete Product',
        it: '',
      },
      deleteProductGroup: {
        el: '',
        en: 'Delete Product Group',
        it: '',
      },
      deleteText: {
        el: '',
        en: 'Are you sure you want to delete',
        it: '',
      },
      search: {
        el: 'Αναζήτηση ',
        en: 'Search',
        it: 'Cerca',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
    },
  }),
};
